import React, { useEffect } from 'react';

function hasContentOnlyQuery() {
  if (typeof window === 'undefined') return false;
  return window.location.search.indexOf('contentonly') > -1;
}

export default function UsaChromeShell({ children }) {
  useEffect(() => {
    if (process.env.NODE_ENV === 'test') return;
    if (typeof window === 'undefined') return;

    const loader = window.USAChromeLoader;
    if (!loader || typeof loader.load !== 'function') {
      // eslint-disable-next-line no-console
      console.warn('USAChromeLoader is not available');
      return;
    }

    const contentOnly = hasContentOnlyQuery();

    loader.load({
      // Fetch directly from the USA origin.
      sourceUrl: 'https://www.usa.edu/',

      // Keep USA theme first, then our app/chrome styles after.
      css: ['https://www.usa.edu/wp-content/themes/mast/dist/css/app.css', '/global/styles/main.css'],

      // Keep existing behavior: when embedded with ?contentonly, links should open in _system.
      linkTarget: contentOnly ? '_system' : '_blank',
      importInlineStyles: true,
    });
  }, []);

  return (
    <>
      <div id="usa-header" />
      <div id="mobile-app">{children}</div>
      <div id="usa-footer" />
    </>
  );
}
